import React, { useEffect, useState } from 'react'
import { ErrorOption, Field, FieldArray, FieldArrayPath, FieldError, FieldErrors, FieldName, FieldRefs, FieldValues, FormState, InternalFieldName, RegisterOptions, set, SubmitErrorHandler, SubmitHandler, useForm, UseFormRegisterReturn } from 'react-hook-form';
import { Button } from '../../components/Buttons';
import Cards from '../../components/Cards';
import { explorePlanAddonsData, freePlanAddons, freeUserUpgradePlan, paidPlanAddonAnnual, paidPlanAddonQuarterly, paidPlanAddons, paidPlanAddonsRightSide } from '../../constants/data';
import { PillsBadge } from '../../components/Badge';
import ProgressBar from '../../components/Progressbar';
import Icons from '../../components/Icons';
import Lists from '../../components/Lists';
import { useNavigate } from 'react-router-dom';
import { useGetCheckoutSessionStatusQuery } from '../../services/settingsSlice';
import { Modal, Switch, Tooltip } from 'antd';
import { useGetCurrentPlanQuery, usePrintInvoiceQuery, usePurchasePlanBillingMutation, usePurchaseQueryMutation } from '../../services/stripe';
import Loading from '../../components/Loading';
import { BrandGAds, BrandGAnalytics, BrandMeta, PaymentSuccess, PlusIcon } from '../../components/Icons/iconImages';
import { CopyButton } from '@mantine/core';
import ReactGA from 'react-ga4';

function Plan() {
  const {
    getValues,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    // defaultValues,
  });

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState('Annual');

  const [analytics, setAnalytics] = useState(false);
  const [adPlatform, setAdPlatform] = useState(false);
  const [shopPlatform, setShopPlatform] = useState(false);

  const [exportEnable, setExportEnable] = useState(true);

  const tabs = ['Monthly', 'Quarterly', 'Annual'];

  const getPlan: any = freeUserUpgradePlan.find((item) => item.planPeriod === selected)
  console.log("getPlan", getPlan);

  const showModal = () => {
    setIsModalOpen(true);
    setSelected(getPlan?.planPeriod === 'Monthly' ? 'Quarterly' : getPlan?.planPeriod === 'Quarterly' ? 'Annual' : getPlan?.planPeriod === 'Annual' ? 'Quarterly' : 'Annual');
  };

  const [paymentmodal, setPaymentModal] = useState(false);


  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const maskSessionId = (sessionId: string) => {
    if (!sessionId) return '';
    const prefix = sessionId.startsWith('cs_live_') ? 'cs_live_' : sessionId.startsWith('cs_test_') ? 'cs_test_' : '';
    if (!prefix) return sessionId;

    const remainingPart = sessionId.substring(prefix.length);
    const visiblePart = remainingPart.substring(0, 6);
    // Show only 8 asterisks regardless of actual length
    const maskedPart = '********';

    return `${prefix}${visiblePart}${maskedPart}`;
  };

  const checkout_session_id = new URLSearchParams(window.location.search).get(
    "checkout_session_id"
  );
  const { data: getCheckoutSession, error, isLoading: checkOutLoading } = useGetCheckoutSessionStatusQuery(checkout_session_id, {
    skip: !checkout_session_id
  })


  const { data: exportRes, isFetching: invoiceLoad } = usePrintInvoiceQuery(checkout_session_id, {
    skip: exportEnable
  })


  useEffect(() => {
    if (
      exportRes?.status !== "uninitialized" &&
      exportRes?.status !== "pending"
    ) {
      if (exportRes) {
        var hiddenElement = document.createElement('a');
        var blobPDF = exportRes?.invoice_pdf_url;
        hiddenElement.href = blobPDF;
        hiddenElement.target = '_blank';
        hiddenElement.download = `Invoice.pdf`;
        hiddenElement.click();
        setExportEnable(true);
      } else {
        setExportEnable(true);
      }
    }
  }, [exportRes]);


  const tokenType = localStorage.getItem("oogw.ai_user_type") || "Bearer";

  const { data: getCurrentPlan, isLoading: currentPlanLoading, isError } = useGetCurrentPlanQuery('');

  useEffect(() => {
    if (checkout_session_id && getCheckoutSession) {
      setPaymentModal(true);
    }
  }, [checkout_session_id, getCheckoutSession])


  useEffect(() => {
    const currentPlan = getCurrentPlan || {};
    if (currentPlan) {
      setAnalytics(currentPlan.google_analytics === "paid");
      setAdPlatform(currentPlan.googleads_meta === "paid");
      setShopPlatform(currentPlan.shopify === "paid");
    }
  }, [getCurrentPlan])

  const checkBoolean = { analytics, adPlatform, shopPlatform };
  const isTwoOrMoreTrue = Object.values(checkBoolean).filter(value => value === true).length;


  const purchaseObject = localStorage.getItem('purchaseObject');
  const purchaseData = purchaseObject ? JSON.parse(purchaseObject) : null;

  const queryLimit = localStorage.getItem("queryLimit");
  const queryLimitData = queryLimit ? JSON.parse(queryLimit) : null;

  const paymentMetadata = localStorage.getItem('paymentMetadata');
  const paymentMetadataData = paymentMetadata ? JSON.parse(paymentMetadata) : null;

  const [purchasePlanBilling, { isSuccess: planBillingSuccess, isError: planBillingError }] = usePurchasePlanBillingMutation();
  const [purchaseQuery, { isSuccess: querySuccess, isError: queryError }] = usePurchaseQueryMutation();
  const [purchasePayload, setPurchasePayload] = useState<any>(null);
  const [queryPayload, setQueryPayload] = useState<any>(null);

  useEffect(() => {
    if (checkout_session_id && getCheckoutSession?.payment_status === 'paid') {
      if (queryLimitData) {
        const payload = { "query_limit": queryLimitData };
        setQueryPayload(payload);
        purchaseQuery(payload);
      } else if (purchaseData) {
        setPurchasePayload(purchaseData);
        purchasePlanBilling(purchaseData);
      }
    }
  }, [checkout_session_id, getCheckoutSession?.payment_status]);

  useEffect(() => {
    if (querySuccess && queryPayload) {
      // Send GA4 purchase event for query addon
      if (paymentMetadataData && getCheckoutSession) {
       
        ReactGA.event('purchase', {
          transaction_id: getCheckoutSession.session_id || '',
          value: paymentMetadataData.amount || 0,
          currency: 'USD',
          payment_status: 'success',
          payment_date: getCheckoutSession.created ? new Date(getCheckoutSession.created * 1000).toISOString() : new Date().toISOString(),
          purchase_timestamp: paymentMetadataData.timestamp || new Date().toISOString(),
          items: [
            {
              item_id: 'query_addon',
              item_name: paymentMetadataData.product_name || 'Query Addon',
              item_category: 'Query Pack',
              item_variant: paymentMetadataData.plan_period || 'One-time',
              price: paymentMetadataData.amount || 0,
              quantity: paymentMetadataData.quantity || queryPayload.query_limit / 100,
            }
          ]
        });
      }
      localStorage.removeItem('queryLimit');
      localStorage.removeItem('paymentMetadata');
      console.log("purchaseQuery success");
      setQueryPayload(null);
    }
    if (queryError && queryPayload) {
      // Send GA event for query purchase failure
      if (paymentMetadataData && getCheckoutSession) {
      
        ReactGA.event('purchase', {
          transaction_id: getCheckoutSession.session_id || '',
          payment_status: 'failed',
          product_name: paymentMetadataData.product_name || 'Query Addon',
          plan_name: paymentMetadataData.plan_period || 'One-time',
          amount: paymentMetadataData.amount || 0,
          currency: 'USD',
          payment_date: getCheckoutSession.created ? new Date(getCheckoutSession.created * 1000).toISOString() : new Date().toISOString(),
          purchase_type: 'query_addon',
        });
      }
      console.log("purchaseQuery error");
      setQueryPayload(null);
    }
  }, [querySuccess, queryError, queryPayload, paymentMetadataData, getCheckoutSession]);

  useEffect(() => {
    if (planBillingSuccess && purchasePayload) {
      // Send GA4 purchase event for plan upgrade
      if (paymentMetadataData && getCheckoutSession) {
       
        ReactGA.event('purchase', {
          transaction_id: getCheckoutSession.session_id || '',
          value: paymentMetadataData.amount || purchasePayload.amount,
          currency: 'USD',
          payment_status: 'success',
          payment_date: getCheckoutSession.created ? new Date(getCheckoutSession.created * 1000).toISOString() : new Date().toISOString(),
          purchase_timestamp: paymentMetadataData.timestamp || new Date().toISOString(),
          items: [
            {
              item_id: 'pro_plan',
              item_name: paymentMetadataData.product_name || 'Pro Plan',
              item_category: 'Subscription Plan',
              item_variant: paymentMetadataData.plan_period || purchasePayload.purchase_plan,
              price: paymentMetadataData.amount || purchasePayload.amount,
              quantity: 1,
              duration_months: paymentMetadataData.quantity || 1,
              analytics_enabled: paymentMetadataData.integrations?.analytics || false,
              ad_platform_enabled: paymentMetadataData.integrations?.adPlatform || false,
              shop_platform_enabled: paymentMetadataData.integrations?.shopPlatform || false,
              total_integrations: paymentMetadataData.integrations?.count || 0,
            }
          ]
        });
      }
      localStorage.removeItem('purchaseObject');
      localStorage.removeItem('paymentMetadata');
      console.log("purchasePlanBilling success");
      setPurchasePayload(null);
    }
    if (planBillingError && purchasePayload) {
      // Send GA event for plan purchase failure
      if (paymentMetadataData && getCheckoutSession) {
      

        ReactGA.event('purchase', {
          transaction_id: getCheckoutSession.session_id || '',
          payment_status: 'failed',
          product_name: paymentMetadataData.product_name || 'Pro Plan',
          plan_name: paymentMetadataData.plan_period || purchasePayload.purchase_plan,
          amount: paymentMetadataData.amount || purchasePayload.amount,
          currency: 'USD',
          payment_date: getCheckoutSession.created ? new Date(getCheckoutSession.created * 1000).toISOString() : new Date().toISOString(),
          purchase_type: 'plan_upgrade',
        });
      }
      console.log("purchasePlanBilling error");
      setPurchasePayload(null);
    }
  }, [planBillingSuccess, planBillingError, purchasePayload, paymentMetadataData, getCheckoutSession]);



  console.log("purchaseData", purchaseData);


  const handleSave = () => {
    try {
      // console.log(getValues())
      // navigate('/company-settings/checkout-payment', {
      //   state: {
      //     amount: 100
      //   }
      // })
      // window.location.href = 'https://buy.stripe.com/test_00weVddpv6zA54l1Ikew800';
      showModal()
    } catch (err) {
      console.log(err)
    }
  }

  const rightSidePurchasePlan = selected === 'Monthly' ? paidPlanAddonsRightSide : selected === 'Quarterly' ? paidPlanAddonQuarterly : paidPlanAddonAnnual;
  const leftSidePurchasePlan = getCurrentPlan?.plan === 'Annual' ? paidPlanAddonAnnual : getCurrentPlan?.plan === 'Quarterly' ? paidPlanAddonQuarterly : paidPlanAddons;

  if (checkOutLoading || currentPlanLoading) {
    return <Loading />
  }
  return (

    <>
      {/* {checkout_session_id && getCheckoutSession && <div className='mb-12'>
        <h2 className='text-2xl font-semibold'>Payment Status : <span className={getCheckoutSession?.payment_status === 'paid' ? 'text-green-500' : 'text-red-500'}>{getCheckoutSession?.payment_status}</span></h2>
        <p className=' text-black-500'>Amount : {getCheckoutSession?.amount_total / 100} </p>
        <p className=' text-black-500'>Currency : {getCheckoutSession?.currency} </p>
        <p>Session Id :{getCheckoutSession?.session_id}</p>
        <p>Time:   {new Date(getCheckoutSession?.created * 1000).toISOString().slice(0, 19).replace('T', ' ')}</p>
      </div>} */}
      <Cards variant='secondary' classname='md:p-6' childClassName={'flex-col'}>
        <form onSubmit={handleSubmit(handleSave)} className='grid grid-cols-1 divide-y-2'>
          <div className="flex items-start justify-between pb-4">
            <div>
              <h4>Plan</h4>
              <h5 className="font-normal">Check and update your plan details here.</h5>
            </div>
          </div>


          <>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6'>
              <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-2 border border-slate-300 p-4 rounded-xl mt-2 mb-4'>
                <div className='flex flex-wrap items-center gap-2'>
                  <p className='text-[#535862] font-normal text-sm sm:text-base'>{tokenType === "Shopify" ? "Shopify queries are FREE" : "Queries Used"}</p>
                  <PillsBadge title={`${getCurrentPlan?.query_count ?? 0}/${getCurrentPlan?.query_limit ?? 0}`} control={control} name={''} />
                </div>
                <div className='w-full sm:w-auto'>
                  {tokenType !== "Shopify" && <button className='text-[#279964] text-sm font-semibold rounded-full bg-white w-full sm:w-auto px-4 py-2 border border-[#279964]' type='button' onClick={() => navigate('/company-settings/plan/checkout', {
                    state: {
                      query: true
                    }
                  })}>Add More</button>}
                </div>
              </div>


              <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-2 border border-slate-300 p-4 rounded-xl mt-2 mb-4'>
                <div className='flex flex-wrap items-center gap-2'>
                  <div className='flex items-center gap-2'>
                    <p className='text-[#535862] font-normal text-sm sm:text-base'>Additional Integrations</p>
                    {tokenType === "Shopify" && <div className='flex items-center'>(<BrandGAnalytics className="h-5 w-5" /><BrandMeta className="h-5 w-5" /><BrandGAds className="h-5 w-5" />)</div>}
                  </div>
                  <PillsBadge title={isTwoOrMoreTrue ? isTwoOrMoreTrue.toString() : '0'} control={control} name={''} />
                  <p className='text-[#279964] font-semibold text-sm cursor-pointer' onClick={() => {
                    navigate("/integrations")
                  }}>Configure</p>
                </div>
                <div className='w-full sm:w-auto'>
                  {isTwoOrMoreTrue < 3 && <button className='text-[#279964] text-sm font-semibold rounded-full bg-white w-full sm:w-auto px-4 py-2 border border-[#279964]' type='button' onClick={() => {
                    if (isTwoOrMoreTrue > 0) {
                      navigate('/company-settings/plan/checkout', {
                        state: {
                          data: getPlan,
                          integration: true
                        }
                      })
                    } else {
                      showModal();
                    }
                  }}>Add More</button>}
                </div>
              </div>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:py-2 py-4'>
              <div className='lg:py-4 p-0'>
                <Cards variant='secondary' childClassName={'flex-col gap-3 p-5'}
                  bottomButton={
                    tokenType !== "Shopify" &&
                    <>
                      {getCurrentPlan?.plan === "monthly" ? <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-2'>
                        <button className='text-[#414651] font-semibold rounded-full bg-white w-full sm:flex-1 p-2 border border-slate-300 flex items-center justify-center gap-2'> <PlusIcon /> Add Queries</button>
                        <Button
                          type='primary'
                          htmlType="submit"
                          className="w-full sm:w-auto"
                        // onClick={showModal}
                        >
                          {tokenType === "Shopify" ? 'Upgrade via Oogwai Dashboard' : "Upgrade Plan"}
                        </Button>
                      </div>
                        :
                        <div className='flex flex-col sm:flex-row items-stretch sm:items-center gap-2'>
                          {
                            getCurrentPlan?.plan === "Annual" ?
                              <div className='flex items-center gap-2 flex-1'>
                                <Switch defaultChecked className='autoRenews' />
                                <p className='text-[#414651] font-medium text-xs sm:text-sm'>Auto Renews on Jun 21, 2025</p>
                              </div>
                              :
                              <p className='text-[#535862] font-semibold text-xs sm:text-sm flex-1'>Save upto 33%</p>
                          }
                          <Button
                            type='primary'
                            htmlType="submit"
                            className="w-full sm:w-auto"
                            disabled={isError}
                          >
                            {getCurrentPlan?.plan === "Annual" ? "Manage Plan" : " Change Frequency"}
                          </Button>
                        </div>}
                    </>
                  }>
                  {/* http://localhost:8000/shopify/token?token=U2FsdGVkX1/QYv5fU/JPwgobOpBGJ+KfVJkC3sbHqD9njWfK3yrsX0mCI1NE9hpXFynFfuK+kIMLQZFr8yFZIQ==&email=U2FsdGVkX1/wmJimspPdQ6YI1BGzfH7AcY+StxCF/lM=&shop-domain=oogwaiitest.myshopify.com */}
                  <p className='text-[#535862] font-normal text-sm sm:text-base'>You are currently on</p>
                  <PillsBadge title={getCurrentPlan?.plan ?? 'Monthly'} control={control} name={''} />
                  <h4 className='text-green-700 text-base sm:text-lg'>{getCurrentPlan?.amount_paid ? "Paid" : (tokenType === "Shopify" ? explorePlanAddonsData.plan.title : "Free")}</h4>
                  <h1 className='text-2xl sm:text-3xl'>{explorePlanAddonsData.plan.currency}{getCurrentPlan?.amount_paid ?? explorePlanAddonsData.plan.price.monthly}/{getCurrentPlan?.plan ?? 'mth'}</h1>
                  {/* {tokenType !== "Shopify" && <ProgressBar progress={70} totalValue={3} label={({ progress, totalValue }) => `${2} out of ${totalValue} users`} />} */}
                </Cards>
              </div>
              <div className='lg:py-4 p-0'>
                <Cards variant='secondary' classname='md:p-4 h-full justify-between' childClassName={'flex-col'}>
                  <Lists
                    items={explorePlanAddonsData.items}
                  // icon={<Icons icon={'heroicons-outline:arrow-up-right'} />}
                  />

                  {
                    tokenType === "Shopify" ?

                      <Button
                        type={'primary'}
                        variant='outlined'
                        className={"mt-6  w-full"} onClick={handleSave} disabled={isError}> {getCurrentPlan?.plan === "Annual" ? "Downgrade Plan" : (tokenType === "Shopify" ? "Upgrade via Oogwai Dashboard" : "Upgrade")}</Button>
                      :
                      <Button
                        color='primary'
                        variant='outlined'
                        className={'mt-10  w-full'} onClick={handleSave} disabled={isError}> {getCurrentPlan?.plan === "Annual" ? "Downgrade Plan" : (tokenType === "Shopify" ? "Upgrade via Oogwai Dashboard" : "Upgrade")}</Button>
                  }

                </Cards>
              </div>
            </div>
            {tokenType === "Shopify" && <p className='pl-6 pr-6 pb-6 text-sm border-0'> Note : <span> All billing is handled outside of Shopify. This app does not use Shopify Billing, and the Shopify integration is free for all users</span></p>}

          </>



          {/* <div className='grid grid-cols-12 gap-6  lg:py-4 py-4'>
            <div className='col-span-12 md:col-span-5 lg:py-4 p-0'>
              <Cards variant='secondary' childClassName={'flex-col gap-3 p-5'}
                bottomButton={
                  <div className='flex items-center gap-2'>
                    <button className='text-[#414651] font-semibold rounded-full  bg-white w-full p-2 border border-slate-300 flex items-center gap-2'> <PlusIcon /> Add Queries</button>
                    <Button
                      type='primary'
                      htmlType="submit"
                      className="w-25"
                    // onClick={showModal}
                    >
                      Upgrade Plan
                    </Button>
                  </div>
                }>
                <p className='text-[#535862] font-normal text-base'>You are currently on</p>
                <PillsBadge title={getCurrentPlan?.plan ?? 'Monthly'} control={control} name={''} />
                <h4 className='text-green-700'>{getCurrentPlan?.amount_paid ? "Paid" : explorePlanAddonsData.plan.title}</h4>
                <h1>{explorePlanAddonsData.plan.currency}{getCurrentPlan?.amount_paid ?? explorePlanAddonsData.plan.price.monthly}/{getCurrentPlan?.plan ?? 'mth'}</h1>
                <ProgressBar progress={70} totalValue={3} label={({ progress, totalValue }) => `${2} out of ${totalValue} users`} />
              </Cards>
            </div>
            <div className='col-span-12 md:col-span-7 lg:py-4 p-0'>
              <Cards variant='secondary' classname='md:p-4 h-full justify-between' childClassName={'flex-col'}>
                <Lists
                  items={explorePlanAddonsData.items}
                // icon={<Icons icon={'heroicons-outline:arrow-up-right'} />}
                />
                <Button color="primary" variant="outlined" className='mt-20' onClick={handleSave}>Upgrade</Button>
              </Cards>
            </div>
          </div> */}
        </form>
      </Cards>

      <Modal
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={paymentmodal}
        onOk={() => {
          setPaymentModal(false);
          navigate("/company-settings/plan");
        }}
        onCancel={() => {
          setPaymentModal(false);
          navigate("/company-settings/plan");
        }}
        footer={null}
        width="90%"
        style={{ maxWidth: '400px' }}
        centered
        // styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
      >
        <div className='p-2 sm:p-4'>
          {
            getCheckoutSession?.payment_status === 'paid' ? (
              <>
                <PaymentSuccess className="mx-auto mt-4 sm:mt-6 mb-6 sm:mb-8 w-20 h-20 sm:w-24 sm:h-24" />
                <p className='text-[#181D27] font-semibold text-lg sm:text-xl text-center' >Thanks for your payment</p>
                <p className='text-[#535862] text-xs sm:text-sm text-center mt-2 sm:mt-3'>We're glad to have you onboard. Here are some quick tips to get you up and running.</p>

                <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-4 mt-4 sm:mt-6'>
                  <p className='text-[#181D27] font-semibold text-base sm:text-xl'>Order no.</p>
                  <div className='flex items-center gap-2'>
                    <p className='text-[#535862] text-xs sm:text-sm font-normal break-all'>{maskSessionId(getCheckoutSession?.session_id ?? '')}</p>
                    <CopyButton value={getCheckoutSession?.session_id ?? ''}>
                      {({ copied, copy }) => (
                        <button
                          onClick={copy}
                          className={`text-xs px-2 py-1 rounded border whitespace-nowrap ${
                            copied
                              ? 'bg-green-50 text-green-600 border-green-300'
                              : 'bg-gray-50 text-gray-600 border-gray-300 hover:bg-gray-100'
                          }`}
                        >
                          {copied ? 'Copied!' : 'Copy'}
                        </button>
                      )}
                    </CopyButton>
                  </div>
                </div>
                <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-4 mt-2 sm:mt-3'>
                  <p className='text-[#181D27] font-semibold text-base sm:text-xl'>Order date.</p>
                  <p className='text-[#535862] text-xs sm:text-sm font-normal'>{getCheckoutSession?.created ? new Date(getCheckoutSession?.created * 1000).toISOString().slice(0, 19).replace('T', ' ') : ''}</p>
                </div>

                <div className='flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-2 sm:gap-4 mt-4 sm:mt-3'>
                  <Button
                    type='default'
                    className="mt-6 sm:mt-10 cursor-pointer text-[#414651] text-xs sm:text-sm font-semibold rounded-full bg-white w-full p-2 border border-slate-300"
                    onClick={() => setExportEnable(false)}
                    loading={invoiceLoad}
                  >
                    View Invoice
                  </Button>
                  <Button
                    type='primary'
                    className="w-full mt-2 sm:mt-10 text-xs sm:text-sm"
                    onClick={() => {
                      setPaymentModal(false);
                      navigate('/conversation');
                    }}
                  >
                    Talk to Oogwai
                  </Button>
                </div>
              </>
            ) : (
              <>
                <p className='text-[#FC0D1B] text-lg sm:text-xl text-center font-semibold'>Payment Failed</p>
                <p className='text-[#535862] text-xs sm:text-sm text-center mt-2 sm:mt-3'>Your payment could not be processed. Please try again or contact support if the issue persists.</p>

                <Button
                  type='primary'
                  className="w-full mt-6 sm:mt-10 text-xs sm:text-sm"
                  onClick={() => {
                    setPaymentModal(false);
                    navigate('/company-settings/plan');
                  }}
                >
                  Close
                </Button>
              </>
            )
          }
        </div>


      </Modal>

      <Modal
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width="95%"
        style={{ maxWidth: '800px' }}
      >
        <div className='p-3 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4'>
          <div className='bg-[#FAFAFA] p-3 sm:p-4 rounded-xl'>
            <p className='text-[#181D27] font-semibold text-base sm:text-lg 2xl:text-xl text-center'>{explorePlanAddonsData.plan.currency}{getCurrentPlan?.amount_paid ?? explorePlanAddonsData.plan.price.monthly}/{getCurrentPlan?.plan ?? 'mth'}</p>
            <p className='text-[#181D27] font-semibold text-base sm:text-lg 2xl:text-xl text-center'>{getCurrentPlan?.amount_paid ? "Paid" : (tokenType === "Shopify" ? explorePlanAddonsData.plan.title : "Free")}</p>
            <p className='text-[#535862] font-normal text-xs sm:text-sm 2xl:text-base text-center'>To get you started!</p>

            <div className='grid grid-cols-1 gap-2 mt-3 sm:mt-4'>
              {(getCurrentPlan?.plan === "Quarterly" || getCurrentPlan?.plan === "Annual") && <>
                <div className='text-[#535862] font-normal text-xs sm:text-sm p-2 border border-slate-300 rounded-xl mt-4 sm:mt-6'>
                  Everything in {getCurrentPlan?.plan === "Quarterly" ? 'Monthly' : "Quarterly"}
                </div>
                <PlusIcon className='mt-2 sm:mt-3 mx-auto' />
              </>}
              {
                leftSidePurchasePlan?.map((item, index) => {
                  return (
                    <div key={index} className='flex items-start sm:items-center gap-2 sm:gap-4 mt-2 sm:mt-3'>
                      {item.icon && <div className='h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] flex-shrink-0'>{item.icon}</div>}
                      <p className='text-[#535862] font-normal text-xs sm:text-sm'>{item.description} {item.description === "Additional integrations" && <PillsBadge title='from $10/mo' control={control} name={''} />}</p>
                    </div>
                  )
                })
              }
            </div>
            <button className='cursor-auto text-[#A4A7AE] text-xs sm:text-sm font-semibold rounded-full bg-white w-full mt-4 sm:mt-6 p-2 border border-slate-300'>Your current Plan</button>

          </div>
          <div className='border border-slate-400 rounded-xl p-3 sm:p-4'>
            <div className="flex flex-wrap justify-center items-center gap-1 sm:gap-0 bg-gray-100 rounded-full border border-slate-300 p-1">
              {tabs.map((tab) => {
                const isDisabled = getCurrentPlan?.plan === tab;
                const tooltipText = `You are already on ${tab} plan`;

                return (
                  <Tooltip key={tab} title={isDisabled ? tooltipText : ''}>
                    <button
                      disabled={isDisabled}
                      onClick={() => setSelected(tab)}
                      className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium transition-colors duration-200
            ${selected === tab
                        ? 'bg-white shadow text-[#414651] border border-slate-300'
                        : getCurrentPlan?.plan === tab ? 'text-[#A4A7AE]' : 'text-[#717680] hover:text-gray-700'}`}
                    >
                      {tab}
                    </button>
                  </Tooltip>
                );
              })}
            </div>
            <p className='text-[#535862] text-xs text-center mt-4 sm:mt-6'>From</p>
            <p className='text-[#181D27] font-semibold text-xl sm:text-2xl 2xl:text-3xl text-center'> {`${getPlan?.currency}${getPlan?.price}/${getPlan?.description}`}</p>

            {/* <p className='text-[#181D27] font-semibold text-lg text-center mt-6'>Paid</p> */}
            {/* <p className='text-[#535862] font-normal text-base text-center'>Upgradable to 4 data sources</p> */}

            {(selected === "Quarterly" || selected === "Annual") && <>

              <div className='text-[#535862] font-normal text-xs sm:text-sm p-2 border border-slate-300 rounded-xl mt-4 sm:mt-6'>
                Everything in {selected === "Quarterly" ? 'Monthly' : "Quarterly"}
              </div>
              <PlusIcon className='mt-2 sm:mt-3 mx-auto' />
            </>}
            <div className='grid grid-cols-1 gap-2 mt-3 sm:mt-4'>
              {
                rightSidePurchasePlan?.map((item, index) => {
                  return (
                    <div key={index} className='flex items-start sm:items-center gap-2 sm:gap-4 mt-2 sm:mt-3'>
                      {item.icon && <div className='h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] flex-shrink-0'>{item.icon}</div>}
                      <p className='text-[#535862] font-normal text-xs sm:text-sm'>{item.description} {item.description === "Additional integrations" && <PillsBadge title='from $10/mo' control={control} name={''} />}</p>
                    </div>
                  )
                })
              }
            </div>
            <Button
              type='primary'
              // htmlType="submit"
              className="w-full mt-6 sm:mt-10 text-xs sm:text-sm"
              onClick={() => navigate('/company-settings/plan/checkout', {
                state: {
                  data: getPlan
                }
              })}
            >
              {getCurrentPlan?.plan === "Annual" ? "Downgrade Plan" : (tokenType === "Shopify" ? "Upgrade via Oogwai Dashboard" : "Upgrade Now")}
            </Button>

          </div>

        </div>
        {tokenType === "Shopify" && <p className='px-3 sm:px-6 pb-3 sm:pb-6 text-xs sm:text-sm'> Note : <span> All billing is handled outside of Shopify. This app does not use Shopify Billing, and the Shopify integration is free for all users</span></p>}
      </Modal>
    </>
  )
}

export default Plan